import i18next from "i18next";
import AccountProfile_enUS from "./enUS/AccountProfile.en-US.json";
import AccountProfile_frFR from "./frFR/AccountProfile.fr-FR.json";
import AccountProfile_deDE from "./deDE/AccountProfile.de-DE.json";
import AccountProfile_nlNL from "./nlNL/AccountProfile.nl-NL.json";
import AccountProfile_esES from "./esES/AccountProfile.es-ES.json";
import AccountProfile_itIT from "./itIT/AccountProfile.it-IT.json";
import AccountProfile_plPL from "./plPL/AccountProfile.pl-PL.json";
import AccountProfile_ptPT from "./ptPT/AccountProfile.pt-PT.json";
import BillingAndPayment_enUS from "./enUS/BillingAndPayment.en-US.json";
import BillingAndPayment_frFR from "./frFR/BillingAndPayment.fr-FR.json";
import BillingAndPayment_deDE from "./deDE/BillingAndPayment.de-DE.json";
import BillingAndPayment_nlNL from "./nlNL/BillingAndPayment.nl-NL.json";
import Header_enUS from "./enUS/Header.en-US.json";
import Header_frFR from "./frFR/Header.fr-FR.json";
import Header_deDE from "./deDE/Header.de-DE.json";
import Header_nlNL from "./nlNL/Header.nl-NL.json";
import Header_esES from "./esES/Header.es-ES.json";
import Header_itIT from "./itIT/Header.it-IT.json";
import Header_plPL from "./plPL/Header.pl-PL.json";
import Header_ptPT from "./ptPT/Header.pt-PT.json";
import Login_enUS from "./enUS/Login.en-US.json";
import Login_frFR from "./frFR/Login.fr-FR.json";
import Login_deDE from "./deDE/Login.de-DE.json";
import Login_nlNL from "./nlNL/Login.nl-NL.json";
import Login_esES from "./esES/Login.es-ES.json";
import Login_itIT from "./itIT/Login.it-IT.json";
import Login_plPL from "./plPL/Login.pl-PL.json";
import Login_ptPT from "./ptPT/Login.pt-PT.json";
import SupportCases_enUS from "./enUS/SupportCases.en-US.json";
import SupportCases_frFR from "./frFR/SupportCases.fr-FR.json";
import SupportCases_deDE from "./deDE/SupportCases.de-DE.json";
import SupportCases_nlNL from "./nlNL/SupportCases.nl-NL.json";
import SupportCases_esES from "./esES/SupportCases.es-ES.json";
import SupportCases_itIT from "./itIT/SupportCases.it-IT.json";
import SupportCases_plPL from "./plPL/SupportCases.pl-PL.json";
import SupportCases_ptPT from "./ptPT/SupportCases.pt-PT.json";
import LeftNavigation_enUS from "./enUS/LeftNavigation.en-US.json";
import LeftNavigation_frFR from "./frFR/LeftNavigation.fr-FR.json";
import LeftNavigation_deDE from "./deDE/LeftNavigation.de-DE.json";
import LeftNavigation_nlNL from "./nlNL/LeftNavigation.nl-NL.json";
import LeftNavigation_esES from "./esES/LeftNavigation.es-ES.json";
import LeftNavigation_itIT from "./itIT/LeftNavigation.it-IT.json";
import LeftNavigation_plPL from "./plPL/LeftNavigation.pl-PL.json";
import LeftNavigation_ptPT from "./ptPT/LeftNavigation.pt-PT.json";

import ManageInvoice_enUS from "./enUS/ManageInvoice.en-US.json";
import ManageInvoice_frFR from "./frFR/ManageInvoice.fr-FR.json";
import ManageInvoice_deDE from "./deDE/ManageInvoice.de-DE.json";
import ManageInvoice_nlNL from "./nlNL/ManageInvoice.nl-NL.json";

import ContractsAndServices_enUS from "./enUS/ContractsAndServices.en-US.json";
import ContractsAndServices_frFR from "./frFR/ContractsAndServices.fr-FR.json";
import ContractsAndServices_deDE from "./deDE/ContractsAndServices.de-DE.json";
import ContractsAndServices_nlNL from "./nlNL/ContractsAndServices.nl-NL.json";

import RedBall_nlNL from "./nlNL/RedBall.nl-NL.json";
import RedBall_deDE from "./deDE/RedBall.de-DE.json";
import RedBall_frFR from "./frFR/RedBall.fr-FR.json";
import RedBall_enUS from "./enUS/RedBall.en-US.json";
import RedBall_esES from "./esES/RedBall.es-ES.json";
import RedBall_itIT from "./itIT/RedBall.it-IT.json";
import RedBall_plPL from "./plPL/RedBall.pl-PL.json";
import RedBall_ptPT from "./ptPT/RedBall.pt-PT.json";

i18next.init({
  lng: "en",
  resources: {
    deDE: {
      accountTranslation: AccountProfile_deDE,
      billingTranslation: BillingAndPayment_deDE,
      headerTranslation: Header_deDE,
      navigationTranslation: LeftNavigation_deDE,
      loginTranslation: Login_deDE,
      casesTranslation: SupportCases_deDE,
      leftNavigationTranslation: LeftNavigation_deDE,
      manageInvoiceTranslation: ManageInvoice_deDE,
      contractsTranslation: ContractsAndServices_deDE,
      redBallTranslation: RedBall_deDE,
    },
    enUS: {
      accountTranslation: AccountProfile_enUS,
      billingTranslation: BillingAndPayment_enUS,
      headerTranslation: Header_enUS,
      navigationTranslation: LeftNavigation_enUS,
      loginTranslation: Login_enUS,
      casesTranslation: SupportCases_enUS,
      leftNavigationTranslation: LeftNavigation_enUS,
      manageInvoiceTranslation: ManageInvoice_enUS,
      contractsTranslation: ContractsAndServices_enUS,
      redBallTranslation: RedBall_enUS,
    },
    frFR: {
      accountTranslation: AccountProfile_frFR,
      billingTranslation: BillingAndPayment_frFR,
      headerTranslation: Header_frFR,
      navigationTranslation: LeftNavigation_frFR,
      loginTranslation: Login_frFR,
      casesTranslation: SupportCases_frFR,
      leftNavigationTranslation: LeftNavigation_frFR,
      manageInvoiceTranslation: ManageInvoice_frFR,
      contractsTranslation: ContractsAndServices_frFR,
      redBallTranslation: RedBall_frFR,
    },
    nlNL: {
      accountTranslation: AccountProfile_nlNL,
      billingTranslation: BillingAndPayment_nlNL,
      headerTranslation: Header_nlNL,
      navigationTranslation: LeftNavigation_nlNL,
      loginTranslation: Login_nlNL,
      casesTranslation: SupportCases_nlNL,
      leftNavigationTranslation: LeftNavigation_nlNL,
      manageInvoiceTranslation: ManageInvoice_nlNL,
      contractsTranslation: ContractsAndServices_nlNL,
      redBallTranslation: RedBall_nlNL,
    },
    esES: {
      accountTranslation: AccountProfile_esES,
      headerTranslation: Header_esES,
      navigationTranslation: LeftNavigation_esES,
      loginTranslation: Login_esES,
      casesTranslation: SupportCases_esES,
      leftNavigationTranslation: LeftNavigation_esES,
      redBallTranslation: RedBall_esES,
    },
    itIT: {
      accountTranslation: AccountProfile_itIT,
      headerTranslation: Header_itIT,
      navigationTranslation: LeftNavigation_itIT,
      loginTranslation: Login_itIT,
      casesTranslation: SupportCases_itIT,
      leftNavigationTranslation: LeftNavigation_itIT,
      redBallTranslation: RedBall_itIT,
    },
    plPL: {
      accountTranslation: AccountProfile_plPL,
      headerTranslation: Header_plPL,
      navigationTranslation: LeftNavigation_plPL,
      loginTranslation: Login_plPL,
      casesTranslation: SupportCases_plPL,
      leftNavigationTranslation: LeftNavigation_plPL,
      redBallTranslation: RedBall_plPL,
    },
    ptPT: {
      accountTranslation: AccountProfile_ptPT,
      headerTranslation: Header_ptPT,
      navigationTranslation: LeftNavigation_ptPT,
      loginTranslation: Login_ptPT,
      casesTranslation: SupportCases_ptPT,
      leftNavigationTranslation: LeftNavigation_ptPT,
      redBallTranslation: RedBall_ptPT,
    },
  },
  ns: [
    "accountTranslation",
    "billingTranslation",
    "headerTranslation",
    "navigationTranslation",
    "loginTranslation",
    "casesTranslation",
    "leftNavigationTranslation",
    "manageInvoiceTranslation",
    "contractsTranslation",
  ],
  defaultNS: "translations",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    formatSeparator: ",",
  },
  react: {
    useSuspense: true,
  },
});

export default i18next;
